// src/components/ui/TranslationLoader.tsx
const TranslationLoader = () => {
    return (
        <div className="flex h-screen w-screen flex-col items-center justify-center bg-white dark:bg-gray-950">
            {/* Spinner Ring */}
            <div className="relative flex items-center justify-center">
                <div className="h-12 w-12 animate-spin rounded-full border-4 border-gray-200 border-t-indigo-600"></div>
                {/* Opsional: Logo kecil di tengah jika spinner cukup besar */}
            </div>

            {/* Text Animation */}
            <div className="mt-5 flex flex-col items-center gap-1">
                <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-100">
                    Please wait
                </h3>
                <p className="animate-pulse text-sm text-gray-500 dark:text-gray-400">
                    Preparing translations...
                </p>
            </div>
        </div>
    );
};

export default TranslationLoader;